import React, {
    FunctionComponent as FC,
    useRef,
    useEffect,
    useState,
} from "react";

import { useNavigate, Link, useParams } from 'react-router-dom';
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux'; // To call Action Creators
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../../state';
import { State } from '../../../../../state/reducers';
import { Button, Row, Col, Form, Input, Checkbox, Layout, Typography, message } from "antd";
const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

interface VerifyEamilProps {

}

const VerifyEmail: FC<VerifyEamilProps> = (props) => {
    const {
    } = props

    const navigate = useNavigate();
    const dispatch = useDispatch()
    const {
        performVerifyEmail,
    } = bindActionCreators(actionCreators, dispatch)
    const { token } = useParams();
    const verifyStatus: boolean = useSelector((state: State) => state.uiReducer?.verifyEmail.verifyStatus) as boolean;

    useEffect(() => {
        if (verifyStatus) {
            navigate('/login');
            // message.success('Verify eamil successfully!');
        }

    }, [verifyStatus]);


    // Function to handle form submission
    const onFinish = () => {
        if (token) {
            const verify_values = {
                token: token
            };
            performVerifyEmail(verify_values);
        }
    };

    // Function to handle submission failure
    const onFinishFailed = (errorInfo: any) => {
        console.log('Verify email failed:', errorInfo);
        message.error('Submission failed, please try again.');
    };

    return (
        <Layout className="verify-layout">
            <Header style={{ backgroundColor: 'transparent', boxShadow: "none" }}>
                <Row justify="space-between" style={{ width: '100%' }}>
                    <Col xs={8} sm={8} md={8} lg={8}>
                        <div className='header-left-div'>
                            <div className='logo'>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Header>
            <Content className="verify-content">
                <div className="verify-wrapper">
                    <div className="branding-section">
                        <div className="branding-container">
                            <div className="branding-text">Funding the Frontier</div>
                            <div className="branding-tagline">Visualizing the Broad Impact of Science and Science Funding</div>
                        </div>
                        <div className='branding-copyright'>
                            Copyright © 2022-2024 CSSI
                        </div>
                    </div>
                    <div className="content-wrapper">
                        <div className="verify-form">
                            {/* <div className="verify-text">Log in</div> */}
                            <Form
                                name="verify"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                initialValues={{ remember: false }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off"
                            >
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="verify-email-form-button">
                                        Verify Eamil
                                    </Button>
                                </Form.Item>
                                <div className="login-link">
                                    <Link to="/login">Back to Login</Link>
                                </div>
                                <div className="verify-form-footer">
                                    {/*<Link to="/verify" className="link">verify</Link>*/}
                                    {/*<Link to="/delete-account" className="link">Delete Account</Link>*/}
                                </div>
                            </Form>


                        </div>
                    </div>
                </div>
            </Content>
            {/* <Footer className="verify-footer">
                <Text>Copyright © 2022-2024 CSSI</Text>
              </Footer> */}
        </Layout>
    );


}

export default VerifyEmail;
